import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BASE_URL_TOKEN, SearchCriteria, Tenant } from '@raptor-fe/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';

@Injectable({
    providedIn: 'root',
})
export class TenantService {
    protected readonly http = inject(HttpClient);
    protected readonly baseUrl = inject(BASE_URL_TOKEN);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    delete(id: string): Observable<object> {
        return this.http.delete<object>(`${this.baseUrl}v1/tenant/${id}`);
    }

    get(id: string): Observable<Tenant | null> {
        if (id === null || id === undefined || id === '') return of(<Tenant>{ id: id, branches: [], isStandalone: false });
        else return this.http.get<Tenant>(`${this.baseUrl}v1/tenant/${id}`);
    }

    save(tenant: Tenant, isNew: boolean): Observable<Tenant> {
        const url = `${this.baseUrl}v1/tenant`;

        if (isNew) {
            return this.http.post<Tenant>(url, tenant);
        } else {
            return this.http.put<Tenant>(url, tenant);
        }
    }

    search(criteria: SearchCriteria, showLoading = true): Observable<Tenant[]> {
        return this.http.post<Tenant[]>(`${this.baseUrl}v1/tenant/search`, criteria, {
            headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
        });
    }

    sync(
        tenantId: string,
        options: { [key: string]: boolean },
        branchId: string | null,
        serverUrl?: string,
        username?: string,
        password?: string,
        showLoading = true,
    ): Observable<void> {
        let headers: HttpHeaders = new HttpHeaders();
        if (serverUrl) {
            headers = headers.set('Federation-Server-Url', serverUrl);
        }

        if (!showLoading) {
            headers = headers.set('No-Loading', 'true');
        }

        let url = `${this.baseUrl}v1/tenant/sync?tenantId=${tenantId}`;
        if (branchId !== null) {
            url += `&branchId=${branchId}`;
        }

        const body = {
            tenantId: tenantId,
            branchId: branchId,
            options: options,
            serverUrl: serverUrl,
            username: username,
            password: password,
        };

        return this.http.post<void>(url, body, { headers: headers });
    }
}
